import { render, staticRenderFns } from "./ClientHeader.vue?vue&type=template&id=100b08f1&"
import script from "./ClientHeader.vue?vue&type=script&lang=js&"
export * from "./ClientHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports